import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'
import { AddTagButton } from './AddTagButton'
import { Tag } from 'src/interfaces/tag'
import { RemovableTag } from './RemovableTag'
import useCheckPermissions from 'src/hooks/useCheckPermissions'
import { UserPermission } from 'src/constants/user'

interface Props {
  tags: Array<Tag>
  className?: any
  onSelectTag(tag: Tag): void
  onRemoveTag(tag: Tag): void
  /** Passed to AddTagButton for stable E2E selectors (e.g. invite message flow). */
  addTagTriggerDataTestId?: string
  tagMenuItemTestIdPrefix?: string
}

const TagsComponent = ({
  tags,
  className,
  onSelectTag,
  onRemoveTag,
  addTagTriggerDataTestId,
  tagMenuItemTestIdPrefix,
}: Props) => {
  const { hasPermission } = useCheckPermissions()
  const canAssign = hasPermission(UserPermission.AssignContractorTags)

  return (
    <div css={[className]}>
      <div css={tw`w-full`}>
        <Typography css={tw`mb-1.5`} color={colors.SHADES_GREY_400} variant="h6">
          Add tag(s)
        </Typography>
        <div css={tw`flex flex-wrap gap-2`}>
          {canAssign && (
            <AddTagButton
              selectedTags={tags}
              onSelectTag={onSelectTag}
              addTagTriggerDataTestId={addTagTriggerDataTestId}
              tagMenuItemTestIdPrefix={tagMenuItemTestIdPrefix}
            />
          )}
          {tags.map((item) => (
            <RemovableTag
              key={item.name}
              tag={item}
              onRemove={canAssign ? onRemoveTag : undefined}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export const Tags = memo(TagsComponent)
